<template>
  <Cart />
</template>

<script>
import Cart from '@/components/cart/Cart'
import { mapState } from 'vuex'

export default {
  name: 'CartPage',
  components: { Cart },
  computed: {
    ...mapState(['headline']),
  },
  metaInfo() {
    return {
      title: this.$t('meta.other.titleTmpl', {
        h1: this.headline,
      }),
      meta: [
        {
          name: 'robots',
          content: 'noindex, follow',
        },
        {
          name: 'description',
          content: this.$t('meta.other.descriptionTmpl', {
            h1: this.headline,
          }),
        },
      ],
    }
  },
}
</script>
